import { createSlice } from "@reduxjs/toolkit";
import {     reKyc_bankVerifyThunk } from "./thunk";

export const initialState = {
  reKyc_bankVerifyData: [],
  reKyc_bankVerifyError: '', 
  reKyc_bankVerifyLoading: false,
  
  
};

const Re_Kyc_Bank_Verify = createSlice({
  name: "Re_Kyc_Bank_Verify",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(reKyc_bankVerifyThunk.pending, (state) => {
      state.reKyc_bankVerifyLoading = true ;
      state.reKyc_bankVerifyData= [];
      state.reKyc_bankVerifyError='';

  });
    builder.addCase(reKyc_bankVerifyThunk.fulfilled, (state, action) => {
        state.reKyc_bankVerifyData = action.payload.data;
        state.reKyc_bankVerifyLoading = false ;
    });
    builder.addCase(reKyc_bankVerifyThunk.rejected, (state, action) => {
      
      state.reKyc_bankVerifyError =  action?.message || "An unknown error occurred";
      state.reKyc_bankVerifyData = action.payload?.data || {};
        state.reKyc_bankVerifyLoading = false ;
        
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = Re_Kyc_Bank_Verify.actions

export default Re_Kyc_Bank_Verify.reducer;